/**
 * آدرس تصویر کاربر روی pic.paziresh24.com — برای آواتارها پارامتر p=thumb اضافه می‌شود.
 * @see https://pic.paziresh24.com/api/image/16685761?p=thumb
 */

export const PAZIRESH_PIC_LOAD_TIMEOUT_MS = 2000;

function isPazireshPicHost(hostname) {
  return typeof hostname === "string" && hostname.toLowerCase() === "pic.paziresh24.com";
}

/** @param {string|null|undefined} url */
export function isPazireshPicUrl(url) {
  if (url == null || typeof url !== "string") return false;
  const trimmed = url.trim();
  if (!trimmed) return false;
  try {
    return isPazireshPicHost(new URL(trimmed).hostname);
  } catch {
    return false;
  }
}

/**
 * اگر URL مربوط به pic.paziresh24.com باشد، پارامتر p=thumb را تنظیم می‌کند (بقیهٔ query حفظ می‌شود).
 * @param {string|null|undefined} url
 * @returns {string|null|undefined}
 */
export function withPazireshAvatarThumbParam(url) {
  if (url == null || typeof url !== "string") return url;
  const trimmed = url.trim();
  if (!trimmed) return url;
  try {
    const u = new URL(trimmed);
    if (!isPazireshPicHost(u.hostname)) return url;
    u.searchParams.set("p", "thumb");
    return u.toString();
  } catch {
    return url;
  }
}

/**
 * حذف پارامتر thumb از URL پذیرش۲۴ — برای نمایش تصویر بزرگ‌تر (مثلاً صفحه پروفایل).
 * @param {string|null|undefined} url
 * @returns {string|null|undefined}
 */
export function withoutPazireshAvatarThumbParam(url) {
  if (url == null || typeof url !== "string") return url;
  const trimmed = url.trim();
  if (!trimmed) return url;
  try {
    const u = new URL(trimmed);
    if (!isPazireshPicHost(u.hostname)) return url;
    u.searchParams.delete("p");
    return u.toString();
  } catch {
    return url;
  }
}

/** URL تصویر پروفایل بدون thumb */
export function pazireshProfileAvatarUrl(remoteId) {
  if (remoteId == null || remoteId === "") return "";
  const id = String(remoteId).trim();
  if (!id) return "";
  return withoutPazireshAvatarThumbParam(`https://pic.paziresh24.com/api/image/${id}`);
}

/**
 * URL استاندارد آواتار کاربر با thumb (بدون بررسی نقش owner گفت‌وگو).
 * @param {string|number} remoteId
 */
export function pazireshUserAvatarUrl(remoteId) {
  if (remoteId == null || remoteId === "") return "";
  const id = String(remoteId).trim();
  if (!id) return "";
  return withPazireshAvatarThumbParam(`https://pic.paziresh24.com/api/image/${id}`);
}

/**
 * URL آواتار کاربر در UI گفت‌وگو (با thumb).
 * @param {string|number|null|undefined} remoteId
 * @returns {string|null}
 */
export function getPazireshAvatarUrl(remoteId) {
  if (remoteId == null || remoteId === "") return null;
  const url = pazireshUserAvatarUrl(remoteId);
  return url || null;
}
